import { useQueryClient } from '@tanstack/react-query'

import { useFirebaseUser } from '@/hooks/useFirebaseUser'
import { selectIndividualAction } from '@/redux/actions'
import { useAppDispatch } from '@/redux/hooks'

import {
  useIndividualsServicePostV1Individuals,
} from '../client/queries'
import {
  useUsersServiceGetV1UsersMeKey,
} from '../client/queries/common'

export const useCreateIndividual = () => {
  const queryClient = useQueryClient()
  const dispatch = useAppDispatch()
  const { reloadUser } = useFirebaseUser()

  return useIndividualsServicePostV1Individuals({
    onSuccess: async (data) => {
      await reloadUser()
      dispatch(selectIndividualAction(data.id))
      await queryClient.invalidateQueries({
        queryKey: [useUsersServiceGetV1UsersMeKey],
      })
    },
  })
}
